import {
    CLAPI
} from '../clchart/cl.api.js'
import * as DATAS from '../datas/transdata.js'

// export const minute_fields = 'msec,agop,open,maxp,minp,newp,sumv,summ'

// export const FIELD_MINU = DATAS.strsToArray(minute_fields + 'curv,index,diff,rate,avgp')

// export function IominuToEasyMinute(indata) {
//     let minus = []
//     let curminu = 0
//     let agominu = -1
//     let curv = 0

//     const agop = CLAPI.getData(indata, 'agop', 0)
//     for (let index = 0; index < indata.datas.length; index++) {
//         const diff = parseFloat(CLAPI.getData(indata, 'newp', index)) - agop
//         const rate = diff / agop
//         curminu = CLAPI.Utils.getTradeMsecToIndex(indata.datas[index][0], CLAPI.STOCK_TRADETIME);
//         if (curminu === agominu) {
//             minus.pop()
//         }
//         if (minus.length > 0) {
//             let agov = minus.at(-1)
//             curv = CLAPI.getData(indata, 'sumv', index) - agov[5]
//         } else {
//             curv = CLAPI.getData(indata, 'sumv', index)
//         }
//         minus.push(
//             [
//                 CLAPI.getData(indata, 'msec', index),
//                 agop,
//                 CLAPI.getData(indata, 'open', index),
//                 CLAPI.getData(indata, 'maxp', index),
//                 CLAPI.getData(indata, 'minp', index),
//                 CLAPI.getData(indata, 'newp', index),
//                 CLAPI.getData(indata, 'sumv', index),
//                 CLAPI.getData(indata, 'summ', index),
//                 curv,
//                 curminu,
//                 diff,
//                 rate,
//                 CLAPI.getData(indata, 'summ', index)/CLAPI.getData(indata, 'sumv', index)
//             ])
//         agominu = curminu
//     }
//     return {
//         fields: FIELD_MINU,
//         datas: minus
//     }
// }


export function IominuToAxisXinfo(indatas) {
    let timeInfo = []
    let dateInfo = []
    let curdate = 0
    // 这里要生成X轴的数据 
    for (let ms = 0; ms < indatas.length; ms++) {
        const indata = indatas[ms]
        curdate = CLAPI.Utils.getMsecDate(CLAPI.getData(indata, 'msec', 0))
        dateInfo.push(curdate)
        for (let km = 0; km < 240; km++) {
            timeInfo.push(DATAS.fromIndexToMinu(km, CLAPI.STOCK_TRADETIME))
        }
    }
    return {
        timeInfo,
        dateInfo
    }
}

export const iominute_fields = 'msec,agop,open,maxp,minp,newp,sumv,summ,oaskm,iaskm,obidm,ibidm'

export const FIELD_IOMINU = {
    msec: 0, // 按交易时间的分钟索引
    open: 1,
    maxp: 2,
    minp: 3,
    newp: 4,
    sumv: 5,
    summ: 6,
    curv: 7,
    curm: 8,
    curbigm: 9,
    sumbigm: 10,
    index: 11,
    diff: 12,
    rate: 13,
    avgp: 14,
}
export function cloneMinute(src, dst, index) {
    dst[0]  = src[0]
    dst[1]  = src[1]
    dst[2]  = src[2]
    dst[3]  = src[3]
    dst[4]  = src[4]
    dst[5]  = src[5]
    dst[6]  = src[6]
    dst[7]  = 0
    dst[8]  = 0
    dst[9]  = 0
    dst[10] = src[10]
    dst[11] = index % 240
    dst[12] = src[12]
    dst[13] = src[13]
    dst[14] = src[14]
}
export function IominuToMinute(indatas) {
    let minus = []
    let offset = 0
    let incbigm = 0
    for (let ms = 0; ms < indatas.length; ms++) {
        const indata = indatas[ms]

        let agop = parseFloat(CLAPI.getData(indata, 'agop', 0))
        let agominu = -1
        let curv = 0
        let curm = 0
        let sumbigm = 0
        let curbigm = 0
        for (let km = 0; km < 240; km++) {
            minus.push([0,0,0,0,0, 0,0,0,0,0, 0,-1,0,0,0])
        }
        
        for (let index = 0; index < indata.datas.length; index++) {
            let curminu = CLAPI.Utils.getTradeMsecToIndex(indata.datas[index][0], CLAPI.STOCK_TRADETIME);
            if (curminu > 239) {
                curminu = 239
            }
            const diff = parseFloat(CLAPI.getData(indata, 'newp', index)) - agop
            const rate = diff / agop
            if (agominu >= 0) {
                curv = CLAPI.getData(indata, 'sumv', index) - minus[offset + agominu][5]
                curm = CLAPI.getData(indata, 'summ', index) - minus[offset + agominu][6]
            } else {
                curv = CLAPI.getData(indata, 'sumv', index)
                curm = CLAPI.getData(indata, 'summ', index)
            }
            let askm = 0
            let bidm = 0
            for (let fi = 3; fi < 8; fi++) {
                askm += CLAPI.getData(indata, 'oaskm' + fi, index) + CLAPI.getData(indata, 'iaskm' + fi, index)
                bidm += CLAPI.getData(indata, 'obidm' + fi, index) + CLAPI.getData(indata, 'ibidm' + fi, index)
            }
            curbigm = (bidm - askm) - sumbigm
            sumbigm = (bidm - askm)
            
            const nowv = minus[offset + curminu]
            nowv[0] = CLAPI.getData(indata, 'msec', index)
            nowv[1] = CLAPI.getData(indata, 'open', index)
            nowv[2] = CLAPI.getData(indata, 'maxp', index)
            nowv[3] = CLAPI.getData(indata, 'minp', index)
            nowv[4] = CLAPI.getData(indata, 'newp', index)

            nowv[5] = CLAPI.getData(indata, 'sumv', index)
            nowv[6] = CLAPI.getData(indata, 'summ', index)
            nowv[7] = curv
            nowv[8] = curm
            nowv[9] = curbigm / 100

            nowv[10] = (sumbigm + incbigm) / 100
            nowv[11] = curminu
            nowv[12] = diff
            nowv[13] = rate
            nowv[14] = CLAPI.getData(indata, 'summ', index)/CLAPI.getData(indata, 'sumv', index)
        
            agominu = curminu
        }
        incbigm += sumbigm
        // xxx++
        console.log(incbigm, sumbigm);
        offset += 240
    }
    // 处理没有数据的分钟线
    for (let index = 0; index < minus.length; index++) {
        if (minus[index][11] === -1) {
            if (index % 240 === 0) {
                // 向后找
                for (let fi = index + 1; fi < minus.length; fi++) {
                    if (minus[fi][11] !== -1) {
                        cloneMinute(minus[fi], minus[index], index) 
                        break
                    }
                }
            }
            else {
                // 向前找
                for (let fi = index - 1; fi >= 0; fi--) {
                    if (minus[fi][11] !== -1) {
                        cloneMinute(minus[fi], minus[index], index) 
                        break
                    }
                }
            }
        }       
    }
    return {
        fields: FIELD_IOMINU,
        datas: minus
    }
}

export const CHART_MINUTE_FWIN = {
    // 浮动窗口特殊标记
    style: 'fwindow',
    // 头信息定义 通常用于需要特殊显示的数据
    header: {
        display: 'text',
        spaceY: 3,
        spaceX: 1,
        rows: [{
            cols: [{
                align: 'left',
                maxchs: 8,
                field: 'msec',
                clr: 'txt',
                getvar: 'getMinuVar',
            }]
        }],
    },
    // 统一表格信息
    boards: {
        upper: {
            display: 'text', // 顶部信息 text 显示label data根据cols取字段信息 line 显示分隔横线 rate 显示百分比图
            spaceX: 3,
            rows: [
                {
                    cols: [{
                            align: 'left',
                            maxchs: 4,
                            label: '最新',
                            clr: 'label',
                        },
                        {
                            maxchs: 7,
                            field: 'newp',
                            getclr: 'getPrcClr',
                            getvar: 'getPrcVar',
                        },
                    ]
                },
                {
                    cols: [{
                            align: 'left',
                            maxchs: 4,
                            label: '均价',
                            clr: 'label',
                        },
                        {
                            maxchs: 7,
                            field: 'avgp',
                            getclr: 'getPrcClr',
                            getvar: 'getPrcVar',
                        },
                    ]
                },
                {
                    cols: [{
                            align: 'left',
                            maxchs: 4,
                            label: '涨跌',
                            clr: 'label',
                        },
                        {
                            maxchs: 7,
                            field: 'diff',
                            getclr: 'getZeroClr',
                            getvar: 'getFltVar',
                        },
                    ]
                },
                {
                    cols: [{
                            align: 'left',
                            maxchs: 4,
                            label: '涨幅',
                            clr: 'label',
                        },
                        {
                            maxchs: 7,
                            field: 'rate',
                            getclr: 'getZeroClr',
                            getvar: 'getPctVar',
                        },
                    ]
                },
                {
                    cols: [{
                            align: 'left',
                            maxchs: 4,
                            label: '现量',
                            clr: 'label',
                        },
                        {
                            maxchs: 7,
                            field: 'curv',
                            getclr: 'getVolClr',
                            getvar: 'getMnyVar',
                        },
                    ]
                },
                {
                    cols: [{
                            align: 'left',
                            maxchs: 4,
                            label: '总量',
                            clr: 'label',
                        },
                        {
                            maxchs: 7,
                            field: 'sumv',
                            getclr: 'getVolClr',
                            getvar: 'getMnyVar',
                        },
                    ]
                },
                {
                    cols: [{
                            align: 'left',
                            maxchs: 4,
                            label: '总额',
                            clr: 'label',
                        },
                        {
                            maxchs: 7,
                            field: 'summ',
                            getclr: 'getMnyClr',
                            getvar: 'getMnyVar',
                        },
                    ]
                },
            ],
        },
    }
}
// const snap_fields = 'msec,open,maxp,minp,newp,sumv,summ'
// const snap_fields = 'time,agop,open,high,low,newp,volume,money,stophigh,stoplow,cjbs,waskp,waskv,wbidp,wbidv'

export const tick_fields = 'time,agop,newp,volume,cjbs'
export const ARRAY_TICK = DATAS.strsToArray(tick_fields);

const src_snap_fields = 'time,open,high,low,newp,volume,money,agop,stophigh,stoplow,cjbs,waskp,waskv,wbidp,wbidv,askp0,askp1,askp2,askp3,askp4,askp5,askp6,askp7,askp8,askp9,askv0,askv1,askv2,askv3,askv4,askv5,askv6,askv7,askv8,askv9,bidp0,bidp1,bidp2,bidp3,bidp4,bidp5,bidp6,bidp7,bidp8,bidp9,bidv0,bidv1,bidv2,bidv3,bidv4,bidv5,bidv6,bidv7,bidv8,bidv9'
const cur_snap_fields = 'msec,open,maxp,minp,newp,sumv,summ,agop,stopmax,stopmin,cjbs,waskmmpp,waskmmpv,wbidmmpp,wbidmmpv'

const FIELD_SNAP = DATAS.fieldsUpdateFieldsIndex(cur_snap_fields, src_snap_fields, 'diff,rate,mmpr')

const FIELD_TICK = DATAS.fieldsToFieldsIndex('msec,agop,newp,sumv,cjbs,curbs,curv,curvclr');

export function snapshotToSnap(indata) {
    let snaps = []
    for (let index = 0; index < indata.datas.length; index++) {
        const agop = parseFloat(CLAPI.getData(indata, 'agop', index))
        const diff = parseFloat(CLAPI.getData(indata, 'newp', index)) - agop
        const rate = diff / agop
        let askv = 0
        let bidv = 0
        for (let mmpi = 0; mmpi < 10; mmpi++) {
            askv += CLAPI.getData(indata, 'askv' + mmpi, index)
            bidv += CLAPI.getData(indata, 'bidv' + mmpi, index)           
        }
        snaps.push(indata.datas[index])
        snaps.at(-1).push(diff)
        snaps.at(-1).push(rate)
        snaps.at(-1).push(bidv/(askv + bidv))
    }
    return {
        fields: FIELD_SNAP,
        datas: snaps
    }
}
export function snapshotToTick(indata) {
    let ticks = []
    let curvclr = 'vol'
    let curv = 0
    let curbs = 0
    let sumv = 0
    let sumbs = 0
    let newp = 0
    for (let index = 0; index < indata.datas.length; index++) {
        newp = parseFloat(CLAPI.getData(indata, 'newp', index))
        sumv = parseInt(CLAPI.getData(indata, 'volume', index))
        sumbs = parseInt(CLAPI.getData(indata, 'cjbs', index))
        if (index > 0) {
            const agov = ticks.at(-1)
            if (newp > agov[1]) {
                curvclr = 'red'
            } else if (newp < agov[1]) {
                curvclr = 'green'
            } else {
                curvclr = 'vol'
            }
            curv = sumv - curv
            curbs = sumbs - curbs
        } else {
            curv = sumv
            curbs = sumbs
        }
        if (curv > 0) {
            ticks.push(
                [CLAPI.getData(indata, 'time', index),
                    CLAPI.getData(indata, 'agop', index),
                    newp,
                    sumv,
                    sumbs,
                    curbs,
                    curv,
                    curvclr,
                ])
        }
        curv = sumv
        curbs = sumbs
    }
    return {
        fields: FIELD_TICK,
        datas: ticks
    }
}

// 指数实时行情
const FIELD_SNAP_IDX = {
    msec: 0,
    agop: 1,
    open: 2,
    maxp: 3,
    minp: 4,
    newp: 5,
    sumv: 6,
    summ: 7,
    newpups: 8,
    newpdns: 9,
    agopups: 10,
    agopdns: 11,
    openups: 12,
    opendns: 13
}
export const CHART_MINU_MAIN = {
    title: {
        display: 'none' // none 不显示 btn 按钮 text 文字
    },
    axisX: {
        lines: 3,
        display: 'none',
        left: {
            display: 'none', // chunk normal
        },
        right: {
            display: 'none',
        },
        middle: {
            display: 'none',
        },
    },
    axisY: {
        display: 'normal',
        lines: 3,
        left: {
            display: 'both', // none不显示，all, noupper不显示最上面, nofoot不显示最下面 = 显示坐标
            middle: 'before', // 是否有中间值 'before' = 前收盘 ‘zero’ 0为中间值
            format: 'price' // 输出数据的格式 rate, price, vol money
        },
        right: {
            display: 'both', // none不显示，noupper不显示最上面, nofoot不显示最下面 = 显示坐标
            middle: 'before', // 是否有中间值 'before'=前收盘 ‘zero’ 0为中间值
            format: 'rate' // rate, price vol
        }
    },
    lines: [{
            className: CLAPI.ClDrawZLine,
            extremum: { // 如何取极值
                method: 'fixedLeft', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
                maxvalue: ['maxp'], // 参与计算最大值的标签
                minvalue: ['minp'] // 参与计算最小值的标签
            },
            info: {
                fieldX: 'index',
                fieldY: 'newp',
                skipfd: 'index', // 画线时从新定位
            }
        },
        {
            className: CLAPI.ClDrawZLine,
            info: {
                fieldX: 'index',
                skipfd: 'index',
            },
            formula: {
                key: 'MINUAVGP', // 获取数据的key，
                command: `out = this.AVGPRC('summ', 'sumv')` // 均价,要根据股票类型做变化
            }
        },
        {
            className: CLAPI.ClDrawZLine,
            info: { // 输出在信息栏目（title）的数据
                label: ' 5:',
                fieldX: 'index',
                // fieldY: 'newp', // 从key中获取对应的数据标签 用于显示信息用
                skipfd: 'index', // 画线时从新定位
                // format: 'price'
            },
            formula: { // 数据生成方式，都需要基于基本数据，没有formula表示取绑定的数据
                key: 'MINU1', // 生成和获取数据的key，必须要定义一个key，否则当你要使用的时候，并不知道取什么样的数据；
                //另外当客户端修改参数或公式时，可以只修改参数和公式，而不修改key，也可以避免垃圾数据过多
                command: `out = this.MA('newp',5)` // 公式只能输出值到out中
            }
        },
        // {
        //     className: CLAPI.ClDrawZLine,
        //     info: { // 输出在信息栏目（title）的数据
        //         label: ' 10:',
        //         fieldX: 'index',
        //         // fieldY: 'newp', // 从key中获取对应的数据标签 用于显示信息用
        //         skipfd: 'index', // 画线时从新定位
        //         // format: 'price'
        //     },
        //     formula: { // 数据生成方式，都需要基于基本数据，没有formula表示取绑定的数据
        //         key: 'MINU2', // 生成和获取数据的key，必须要定义一个key，否则当你要使用的时候，并不知道取什么样的数据；
        //         //另外当客户端修改参数或公式时，可以只修改参数和公式，而不修改key，也可以避免垃圾数据过多
        //         command: `out = this.MA('newp',10)` // 公式只能输出值到out中
        //     }
        // },
        // {
        //     className: CLAPI.ClDrawZLine,
        //     info: { // 输出在信息栏目（title）的数据
        //         label: ' 20:',
        //         fieldX: 'index',
        //         // fieldY: 'newp', // 从key中获取对应的数据标签 用于显示信息用
        //         skipfd: 'index', // 画线时从新定位
        //         // format: 'price'
        //     },
        //     formula: { // 数据生成方式，都需要基于基本数据，没有formula表示取绑定的数据
        //         key: 'MINU3', // 生成和获取数据的key，必须要定义一个key，否则当你要使用的时候，并不知道取什么样的数据；
        //         //另外当客户端修改参数或公式时，可以只修改参数和公式，而不修改key，也可以避免垃圾数据过多
        //         command: `out = this.MA('newp',20)` // 公式只能输出值到out中
        //     }
        // },
    ]
}
export const CHART_MINUANALY = {
    title: {
        display: 'text', // none 不显示 btn 按钮 text 文字
        label: '分时大单', // 需要显示的文字信息
    },
    axisX: {
        lines: 3,
        left:  {
            display: 'normal',   // chunk normal
            getvar : 'XdataTxt', // 从公共 axisXinfo.dataTxt 获取
        },
        right:  {
            display: 'normal',
            getvar : 'XdataTxt', // 从公共 axisXinfo.dataTxt 获取
        },
        middle:  {
            display: 'chunk',
            getvar : 'XshowTxt', // 从公共 axisXinfo.showTxt 获取
        },
    },
    axisY: {
        display : 'normal',
        lines: 1,
        left: {
            display: 'both',
            middle: 'none',
            format: 'money'
        },
        right: {
            display: 'both',
            middle: 'none',
            format: 'money'
        }
    },
    lines: [{
            className: CLAPI.ClDrawVBar,
            extremum: { // 如何取极值
                method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
                maxvalue: ['sumbigm', 'curbigm'], // 参与计算最大值的标签
                minvalue: ['sumbigm', 'curbigm'] // 参与计算最小值的标签
            },
            info: {
                label: '当前:',
                showstyle: 'zero', // 'normal' 正常显示bar 'zero' 以0上下显示
                fieldX: 'index',
                fieldY: 'curbigm', // 需要显示的变量，从key中获取对应的数据标签
                format: 'money',
            }
        },
        {
            className: CLAPI.ClDrawZLine,
            info: {
                label: '累计:',
                fieldX: 'index',
                fieldY: 'sumbigm', // 需要显示的变量，从key中获取对应的数据标签
                format: 'money',
                color: 'lred'
            },
        },
    ]
}

export const CHART_BOARD_SNAP = {
    // 头信息定义 通常用于需要特殊显示的数据
    header: {
        display: 'text',
        spaceY: 5,
        spaceX: 1,
        rows: [{
                cols: [{
                        align: 'left',
                        maxchs: 8,
                        field: 'name',
                        pixel: 25,
                        clr: 'name',
                        getvar: 'getInfoVar',
                        getclr: 'getNameClr',
                    },
                    {
                        maxchs: 8,
                        field: 'code',
                        pixel: 20,
                        clr: 'code',
                        getvar: 'getInfoVar',
                        getclr: 'getCodeClr',
                    },
                ]
            },
            {
                cols: [{
                        align: 'center',
                        maxchs: 7,
                        field: 'newp',
                        pixel: 20,
                        getclr: 'getPrcClr',
                        getvar: 'getPrcVar',
                    },
                    {
                        align: 'center',
                        maxchs: 7,
                        field: 'diff',
                        pixel: 16,
                        getclr: 'getZeroClr',
                        getvar: 'getFltVar',
                    },
                    {
                        align: 'center',
                        maxchs: 7,
                        field: 'rate',
                        pixel: 16,
                        getclr: 'getPrcClr',
                        getvar: 'getPctVar',
                    },
                ]
            }
        ],
    },
    // 统一表格信息
    boards: {
        upper: {
            display: 'text', // 顶部信息 text 显示label data根据cols取字段信息 line 显示分隔横线 rate 显示百分比图
            spaceX: 3,
            rows: [{
                    cols: [{
                            align: 'left',
                            maxchs: 4,
                            label: '昨收',
                            clr: 'label',
                        },
                        {
                            maxchs: 7,
                            field: 'agop',
                            clr: 'txt',
                        },
                        {
                            align: 'left',
                            maxchs: 4,
                            label: '涨停',
                            clr: 'label',
                        },
                        {
                            maxchs: 7,
                            field: 'stopmax',
                            getclr: 'getPrcClr',
                            getvar: 'getPrcVar',
                        },
                    ]
                },
                {
                    cols: [{
                            align: 'left',
                            maxchs: 4,
                            label: '今开',
                            clr: 'label',
                        },
                        {
                            maxchs: 7,
                            field: 'open',
                            getclr: 'getPrcClr',
                            getvar: 'getPrcVar',
                        },
                        {
                            align: 'left',
                            maxchs: 4,
                            label: '跌停',
                            clr: 'label',
                        },
                        {
                            maxchs: 7,
                            field: 'stopmin',
                            getclr: 'getPrcClr',
                            getvar: 'getPrcVar',
                        },
                    ]
                },
                {
                    cols: [{
                            align: 'left',
                            maxchs: 4,
                            label: '最高',
                            clr: 'label',
                        },
                        {
                            maxchs: 7,
                            field: 'maxp',
                            getclr: 'getPrcClr',
                            getvar: 'getPrcVar',
                        },
                        {
                            align: 'left',
                            maxchs: 4,
                            label: '总量',
                            clr: 'label',
                        },
                        {
                            maxchs: 7,
                            field: 'sumv',
                            getclr: 'getVolClr',
                            getvar: 'getHandVar',
                        },
                    ]
                },
                {
                    cols: [{
                            align: 'left',
                            maxchs: 4,
                            label: '最低',
                            clr: 'label',
                        },
                        {
                            maxchs: 7,
                            field: 'minp',
                            getclr: 'getPrcClr',
                            getvar: 'getPrcVar',
                        },
                        {
                            align: 'left',
                            maxchs: 4,
                            label: '总额',
                            clr: 'label',
                        },
                        {
                            maxchs: 7,
                            field: 'summ',
                            getclr: 'getMnyClr',
                            getvar: 'getVolVar',
                        },
                    ]
                },
            ],
        },
    }
}


export const CHART_BOARD_RMMP = {
    title: {
        display: 'text', // none text 
        label: '买卖盘', // label information to be displayed
    },
    // 统一表格信息
    boards: {
        upper: {
            spaceY: 1,
            display: 'text', // 顶部信息 text 显示label data根据cols取字段信息 line 显示分隔横线 rate 显示百分比图
            rows: [{
                cols: [{
                        align: 'center',
                        maxchs: 2,
                        label: '卖',
                        clr: 'green',
                    },
                    {
                        maxchs: 9,
                        field: 'waskmmpp',
                        getclr: 'getPrcClr',
                        getvar: 'getPrcVar',
                    },
                    {
                        maxchs: 11,
                        field: 'waskmmpv',
                        clr: 'vol',
                        getvar: 'getHandVar',
                        getclr: 'getVolClr',
                    },
                ]
            }, ],
        },
        footnote: {
            spaceY: 1,
            display: 'text', // 底部信息 text 显示label data根据cols取字段信息 line 显示分隔横线 rate 显示百分比图
            rows: [{
                cols: [{
                        align: 'center',
                        maxchs: 2,
                        label: '买',
                        clr: 'red',
                    },
                    {
                        maxchs: 9,
                        field: 'wbidmmpp',
                        getclr: 'getPrcClr',
                        getvar: 'getPrcVar',
                    },
                    {
                        maxchs: 11,
                        field: 'wbidmmpv',
                        clr: 'vol',
                        getvar: 'getHandVar',
                        getclr: 'getVolClr',
                    },
                ]
            }, ],
        },
        middle: {
            spaceY: 0,
            pixel : 5,
            display: 'rate', // 中间信息 text 显示label data根据cols取字段信息 line 显示分隔横线 rate 显示百分比图
            rows: [{
                cols: [{
                    // align: 'center',
                    // maxchs: 2,
                    field: 'mmpr',
                    getvar: 'getPrcVar',
                }]

            }],
        },
    }
}

for (let rmmpi = 9; rmmpi >= 0; rmmpi--) {
    let askrow = {
        cols: []
    }
    askrow.cols.push({
        maxchs: 2,
        align: 'center',
        field: rmmpi + 1,
        clr: 'green',
        getvar: 'getMapVar',
    })
    askrow.cols.push({
        maxchs: 9,
        field: 'askp' + rmmpi,
        getclr: 'getPrcClr',
        getvar: 'getPrcVar',
    })
    askrow.cols.push({
        maxchs: 11,
        field: 'askv' + rmmpi,
        clr: 'vol',
        getvar: 'getHandVar',
    })
    CHART_BOARD_RMMP.boards.upper.rows.push(askrow)

    let bidrow = {
        cols: []
    }
    bidrow.cols.push({
        align: 'center',
        maxchs: 2,
        field: rmmpi + 1,
        clr: 'red',
        getvar: 'getMapVar',
    })
    bidrow.cols.push({
        maxchs: 9,
        field: 'bidp' + rmmpi,
        getclr: 'getPrcClr',
        getvar: 'getPrcVar',
    })
    bidrow.cols.push({
        maxchs: 11,
        field: 'bidv' + rmmpi,
        clr: 'vol',
        getvar: 'getHandVar',
    })
    CHART_BOARD_RMMP.boards.footnote.rows.unshift(bidrow)
}


// console.log(CHART_BOARD_RMMP);

export const CHART_BOARD_TICK = {
    title: {
        display: 'text', // none text 
        label: '分时成交', // label information to be displayed
    },
    // 统一表格信息
    boards: {
        pixel: 14,
        spaceX: 2,
        cols: [{
                align: 'left',
                field: 'msec',
                maxchs: 5,
                clr: 'txt',
                getvar: 'getMinuVar',
            },
            {
                field: 'newp',
                maxchs: 7,
                getclr: 'getPrcClr',
                getvar: 'getPrcVar',
            },
            {
                field: 'curv',
                maxchs: 8,
                fieldclr: 'curvclr',
                getvar: 'getHandVar',
            },
            {
                field: 'curbs',
                maxchs: 5,
                clr: 'txt',
                getvar: 'getIntVar',
            },
        ],
    }
}